import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Modal } from './modal';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent implements Modal {
  @Input() activeModal: NgbActiveModal;
  @Input() title: string;
  @Input() closeBtnLabel = $localize`Zapisz`;
  @Input() dismissBtnLabel = $localize`Anuluj`;
  @Input() isCloseDisabled?: boolean;
  @Input() isDismissDisabled?: boolean;
  @Input() isReadonly?: boolean;
  @Input() isFooterVisible = true;
  @Input() onClose: (arg?: any) => void = this.close;
  @Input() onDismiss: (arg?: any) => void = this.dismiss;

  private close(reason?: any): void {
    this.activeModal.close(reason);
  }

  private dismiss(reason?: any): void {
    this.activeModal.dismiss(reason);
  }
}
